import { DataBean } from "../DataBean";

export class ProjectDataDocumentsType extends DataBean {



    public async getProjectDataDocumentsType(idProject: any, documentsTable: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getProjectDataDocumentsType_Number_String", [idProject, documentsTable]);
    }

}